export default "__VITE_ASSET__DAeC7Uja__"